export default __webpack_public_path__ + "static/media/rnr-sports-table-17.44740e07.webp";